export const SDK_VERSION = '3.3622.42';